import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '@core/services';

@Pipe({
  name: 'declensionString'
})
export class DeclensionStringPipe implements PipeTransform {

  constructor(private locale: LocalizationService) { }

  transform(qtyWithPackageType: string, args: number): string {
    const currentLanguage: string = this.locale.getLang();
    const type: string = qtyWithPackageType;
    const qty: number = Number(args);

    switch (type) {
      case 'ампула':
        if (currentLanguage == 'ua') {
          return ['ампула', 'ампули', 'ампул'][this.idx(qty)];
        } else {
          return ['ампула', 'ампулы', 'ампул'][this.idx(qty)];
        }
      case 'стрип':
        return ['стрип', 'стрипа', 'стрипов'][this.idx(qty)];
      case 'блистер':
        return ['блистер', 'блистера', 'блистеров'][this.idx(qty)];
      case 'флакон':
        return ['флакон', 'флакона', 'флаконов'][this.idx(qty)];
      case 'контейнер':
        return ['контейнер', 'контейнерa', 'контейнеров'][this.idx(qty)];
      case 'пакет':
        return ['пакет', 'пакета', 'пакетов'][this.idx(qty)];
      case 'саше':
        return ['саше', 'саше', 'саше'][this.idx(qty)];
      case 'туба':
        if (currentLanguage == 'ua') {
          return ['туба', 'туби', 'туб'][this.idx(qty)];
        } else {
          return ['туба', 'тубы', 'туб'][this.idx(qty)];
        }
      case 'блістер':
        return ['блістер', 'блістери', 'блістерів'][this.idx(qty)];
      case 'шприц':
        if (currentLanguage == 'ua') {
          return ['шприц', 'шприца', 'шприців'][this.idx(qty)];
        } else {
          return ['шприц', 'шприца', 'шприцов'][this.idx(qty)];
        }
      case 'банка':
        return ['банка', 'банки', 'банок'][this.idx(qty)];
      case 'картридж':
        if (currentLanguage == 'ua') {
          return ['картридж', 'картриджа', 'картриджів'][this.idx(qty)];
        } else {
          return ['картридж', 'картриджа', 'картриджей'][this.idx(qty)];
        }
      case 'конверт':
        if (currentLanguage == 'ua') {
          return ['конверт', 'конверти', 'конвертів'][this.idx(qty)];
        } else {
          return ['конверт', 'конверта', 'конвертов'][this.idx(qty)];
        }
      case 'пачка':
        if (currentLanguage == 'ua') {
          return ['пачка', 'пачки', 'пачок'][this.idx(qty)];
        } else {
          return ['пачка', 'пачки', 'пачек'][this.idx(qty)];
        }
      case 'карандаш':
        return ['карандаш', 'карандаша', 'карандашей'][this.idx(qty)];
      case 'олівець':
        return ['олівець', 'олівця', 'олівців'][this.idx(qty)];
      case 'балон':
        return ['балон', 'балони', 'балонів'][this.idx(qty)];
      case 'баллон':
        return ['баллон', 'баллона', 'баллонов'][this.idx(qty)];
      case 'клізма':
        return ['клізма', 'клізми', 'клізм'][this.idx(qty)];
      case 'клизма':
        return ['клизма', 'клизмы', 'клизм'][this.idx(qty)];
      case 'пляшка':
        return ['пляшка', 'пляшки', 'пляшок'][this.idx(qty)];
      case 'бутылка':
        return ['бутылка', 'бутылки', 'бутылок'][this.idx(qty)];
      case 'фільтр-пакет':
        return ['фільтр-пакет', 'фільтр-пакета', 'фільтр-пакетів'][this.idx(qty)];
      case 'фильтр-пакет':
        return ['фильтр-пакет', 'фильтр-пакета', 'фильтр-пакетов'][this.idx(qty)];
      default:
        break;
    }
  }

  private idx(qty: number): number {
    return qty % 10 === 1 && qty % 100 !== 11 ? 0 : qty % 10 >= 2
      && qty % 10 <= 4 && (qty % 100 < 10 || qty % 100 >= 20) ? 1 : 2
  }
}
